import React, { useState, useEffect } from "react";

import { useList } from "store/list";
import { useCore } from "store/core";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import {
  generate_uuid,
  dateTimeToserver,
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import { required, validationWrapper, number } from "lib/formValidations";
export default function Filters(props) {
  const { setFieldValue } = props;

  return (
    <div className="intro-y p-2 bg-white grid col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2 selector-dark">
      <h3 className="intro-y text-sm font-medium col-span-12 my-2">فیلترها</h3>
      <div className="grid grid-cols-4 gap-x-2 col-span-12">
        <Field
          placeholder={"بر اساس"}
          label={"بر اساس"}
          name={"filter_type"}
          component={Select}
          options={[
            { value: "without_filter", label: "بدون فیلتر" },
            { value: "has_order", label: "دارای خرید" },
            { value: "whitout_order", label: "بدون خرید" },
            { value: "new_user", label: "کاربران جدید" },
            { value: "has_subscription", label: "دارای اشتراک" },
            { value: "has_not_subscription", label: "بدون اشتراک" },
          ]}
        />
        {props.values.filter_type != "without_filter" &&
          props.values.filter_type != "has_subscription" &&
          props.values.filter_type != "has_not_subscription" && (
            <div className="col-span-5 flex justify-center gap-x-1 items-end mt-5">
              <div className="w-56 relative text-gray-700 dark:text-gray-300">
                <Field
                  placeholder="از تاریخ"
                  label="از تاریخ :"
                  name="date_from"
                  component={PersianDataPicker}
                  disable_today={true}
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  setFieldValue("date_to", null);
                  setFieldValue("date_from", null);
                }}
              >
                <svg
                  height="20"
                  width="20"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                  focusable="false"
                  class="css-tj5bde-Svg"
                >
                  <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                </svg>
              </button>
              <div className="w-56 relative text-gray-700 dark:text-gray-300">
                <Field
                  placeholder="تا تاریخ"
                  label="تا تاریخ :"
                  name="date_to"
                  component={PersianDataPicker}
                  disable_today={true}
                />
              </div>
            </div>
          )}
      </div>
    </div>
  );
}
